import script from "./permissions.vue?vue&type=script&setup=true&lang=js"
export * from "./permissions.vue?vue&type=script&setup=true&lang=js"

import "./permissions.vue?vue&type=style&index=0&id=455ae8b7&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-455ae8b7"]])

export default __exports__